<template>
  <div id="gz">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'gz'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/guide/gz/Gz.vue